
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/resources/events-and-callbacks",
      function () {
        return require("private-next-pages/x/react-chat/resources/events-and-callbacks.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/resources/events-and-callbacks"])
      });
    }
  